import { render, staticRenderFns } from "./MyTodos.vue?vue&type=template&id=02bc3df4"
import script from "./MyTodos.vue?vue&type=script&lang=ts"
export * from "./MyTodos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports